import React from 'react'
import {CardLayoutType} from '../../ui/Card'
import {ProductCardPreview} from '../../webshop/layout/product/ProductCard'
import {ProductTaxonomyType, ProductType} from '../../webshop/pages'
import {EventCard, EventCardType} from './EventCard'
import {PageCard, PageCardType} from './PageCard'
import {ProjectCard, ProjectCardType} from './ProjectCard'

export type CardSwitchType = (
	| EventCardType
	| PageCardType
	| ProjectCardType
) & {channel: string}

export const CardSwitch: React.FC<{
	layout?: CardLayoutType
	card: CardSwitchType
	card_linklabel?: string
}> = ({layout, card, card_linklabel}) => {
	switch (layout) {
		case 'event':
			return (
				<EventCard linklabel={card_linklabel} {...(card as EventCardType)} />
			)
		case 'product':
			return (
				<ProductCardPreview {...(card as ProductType & ProductTaxonomyType)} />
			)
		case 'project':
			return <ProjectCard {...(card as ProjectCardType)} />
		default:
			return <PageCard linklabel={card_linklabel} {...(card as PageCardType)} />
	}
}
